export default __webpack_public_path__ + "static/media/eventx-logo.d2fc5439.png";